// Quick Check prefill from the owning student's own confirmed grades (journey) and the
// "Edit in Quick Check" draft. Pure so precedence is unit-tested:
//   in-page edits > server-explicit fields > journey-confirmed facts > draft (unconfirmed) > defaults.
const hasValue = (v) => v !== undefined && v !== null && String(v).trim() !== "";

const coerce = (current, raw) => {
  const n = Number(raw);
  return typeof current === "number" && Number.isFinite(n) ? n : String(raw);
};

export function quickCheckPrefill({ form, journeyProfile, draftItem, touched, serverExplicit }) {
  const g = journeyProfile?.how?.grades || {};
  const c = g.confirmed || {};
  const blocked = (k) => touched.has(k) || serverExplicit.has(k);
  const changes = {};
  const confirmedFields = [];
  const draftFields = [];

  if (c.curriculum === true && hasValue(g.curriculum) && g.curriculum in form && !blocked("curriculum")) {
    changes.curriculum = g.curriculum;
    confirmedFields.push("curriculum");
  }
  const curriculum = changes.curriculum ?? form.curriculum;
  if (c.predicted === true && hasValue(g.predicted) && g.curriculum === curriculum && curriculum in form && !blocked(curriculum)) {
    changes[curriculum] = coerce(form[curriculum], g.predicted);
    confirmedFields.push(curriculum);
  }

  const d = draftItem;
  if (d && d.curriculum && d.curriculum in form) {
    if (d.askCurriculum && !blocked("curriculum") && !confirmedFields.includes("curriculum")) {
      changes.curriculum = d.curriculum;
      draftFields.push("curriculum");
    }
    const target = changes.curriculum ?? form.curriculum;
    if (d.askPredicted && d.curriculum === target && !blocked(target) && !confirmedFields.includes(target)) {
      changes[target] = coerce(form[target], d.predicted);
      draftFields.push(target);
    }
  }
  return { changes, confirmedFields, draftFields };
}
